import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Teleport as _Teleport, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = ["title", "aria-label", "aria-expanded"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "d-inline-block",
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
    onKeydown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("button", {
      ref: "trigger",
      type: "button",
      class: "au-icon-btn",
      title: _ctx.label,
      "aria-label": _ctx.label,
      "aria-haspopup": "menu",
      "aria-expanded": _ctx.open,
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggle && _ctx.toggle(...args)))
    }, _cache[4] || (_cache[4] = [
      _createElementVNode("i", { class: "bi bi-three-dots" }, null, -1)
    ]), 8, _hoisted_1),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (_ctx.open)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "au-menu",
            role: "menu",
            style: _normalizeStyle(_ctx.position),
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, [
            _renderSlot(_ctx.$slots, "default")
          ], 4))
        : _createCommentVNode("", true)
    ]))
  ], 32))
}